import { Extension } from '@tiptap/core';
import type { EditorView } from 'prosemirror-view';
import type { EditorState } from 'prosemirror-state';
import { PluginKey, Plugin } from 'prosemirror-state';

interface StateChangeOptions {
  onStateChange: () => void;
}

export const StateChange = Extension.create<StateChangeOptions>({
  name: 'stateChange',

  addOptions() {
    return {
      onStateChange: () => undefined,
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('stateChange'),
        view: () => ({
          update: (view: EditorView, prevState: EditorState) => {
            if (
              prevState &&
              prevState.doc.eq(view.state.doc) &&
              prevState.selection.eq(view.state.selection)
            ) {
              return;
            }

            this.options.onStateChange();
          },
        }),
      }),
    ];
  },
});
